import axios from 'axios';
import { API_URL, API_VERSION } from 'utils/constants';
import _startCase from 'lodash/startCase';
import { PRODUCT_URL } from 'services/api/urls';

export const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    Accept: `application/vnd.xyzpay.${API_VERSION}+json`,
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  function (config) {
    if (config.url.indexOf(PRODUCT_URL) === -1 && config.method !== 'get') {
      config.transformRequest = [
        function (data, headers) {
          if (!!data) {
            if (data.name) {
              data.name = _startCase(data.name);
            }
            if (!!data.surname) {
              data.surname = _startCase(data.surname);
            }
            if (!!data.first_name) {
              data.first_name = _startCase(data.first_name);
            }
            if (!!data.last_name) {
              data.last_name = _startCase(data.last_name);
            }
            if (!!data.recipient_name) {
              data.recipient_name = _startCase(data.recipient_name);
            }
            return JSON.stringify(data);
          }
          return data;
        },
      ];
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export const axiosGet = (options) => {
  return axiosInstance({
    ...options,
  });
};

export const axiosPost = (options) => {
  return axiosInstance({
    method: 'POST',
    ...options,
  });
};

export const axiosPatch = (options) => {
  return axiosInstance({
    method: 'PATCH',
    ...options,
  });
};

export const axiosDelete = (options) => {
  return axiosInstance({
    method: 'DELETE',
    ...options,
  });
};

export const axiosMultipart = (options) => {
  return axios({
    method: 'POST',
    baseURL: API_URL,
    withCredentials: true,
    headers: {
      Accept: `application/vnd.xyzpay.${API_VERSION}+json`,
      'Content-Type': 'multipart/form-data',
    },
    ...options,
  });
};
